import PropTypes from "prop-types"

export const GRAPH_CONTEXT_SHAPE = PropTypes.shape({
  // Graph-specific state
  selectedCategory: PropTypes.string.isRequired,
  selectedTemplate: PropTypes.string.isRequired,
  disabledItems: PropTypes.object.isRequired,
  isPreferencesLoaded: PropTypes.bool.isRequired,

  // Graph state updaters
  setSelectedCategory: PropTypes.func.isRequired,
  setSelectedTemplate: PropTypes.func.isRequired,
  setDisabledItems: PropTypes.func.isRequired,
  setOnlyItem: PropTypes.func.isRequired,
  enableAllItems: PropTypes.func.isRequired,

  // Parent context values (inherited from dashboard context)
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  period: PropTypes.string,
  earliestDate: PropTypes.string,
  latestDate: PropTypes.string,
  base: PropTypes.string,
  instrument: PropTypes.string,
})
